import { useContext } from 'react'

import { Box, Checkbox, FormControlLabel } from '@material-ui/core'

import ContentModalContext from '../../ContentModalProvider/Context'
import Section from '../../components/Section'
import { FIELD_NAMES, LABELS } from '../../components/constants'
import CharacterLimitInput from '../../../CharacterLimitInput'

const Financial = () => {
  const { item, onUpdateField, validation } = useContext(ContentModalContext)

  return (
    <Section title="Cost & Aid">
      <CharacterLimitInput
        id={FIELD_NAMES.COST_DESCRIPTION}
        value={item[FIELD_NAMES.COST_DESCRIPTION]}
        field={FIELD_NAMES.COST_DESCRIPTION}
        label={LABELS.COST_DESCRIPTION}
        placeholder={LABELS.COST_DESCRIPTION}
        onUpdateField={onUpdateField}
        validation={validation}
      />
      <Box ml={1.5}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={item[FIELD_NAMES.FINANCIAL_AID]}
              onChange={(e) => onUpdateField(FIELD_NAMES.FINANCIAL_AID, e.target.checked)}
              name={FIELD_NAMES.FINANCIAL_AID}
            />
          }
          label={LABELS.FINANCIAL_AID}
        />
      </Box>
    </Section>
  )
}

export default Financial
